// GENERATED FILE - DO NOT MODIFY

export enum UpdateClubMembersActionDto {
    Add = "Add",
    Remove = "Remove",
}